import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SearchComponent } from '../search/search.component';
import { pageNames } from '@library/page-names';
import { SiteResetComponent } from '@user/site-reset/site-reset.component';
import { TicketSelectComponent } from '../ticket-select/ticket-select.component';
import { PayTicketComponent } from '../pay-ticket/pay-ticket.component';
import { AffirmationComponent } from '../affirmation/affirmation/affirmation.component';
import { ViewDocComponent } from '../doc/view-doc/view-doc.component';
import { SampleTicketsNassauComponent } from '../sample-tickets/sample-tickets-nassau/sample-tickets-nassau.component';
import { ReceiptComponent } from '../receipt/receipt/receipt.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/search',
        pathMatch: 'full',
        data: {
            routeID: pageNames.SearchComponent,
            reuse: false,
        },
    },
    {
        path: 'maintenance',
        component: MaintenanceComponent,
        data: {
            routeID: pageNames.MaintenanceComponent,
            reuse: false,
        },
    },
    {
        path: 'search',
        component: SearchComponent,
        data: {
            routeID: pageNames.SearchComponent,
            reuse: false,
        },
    },
    {
        path: 'ticketselect',
        component: TicketSelectComponent,
        data: {
            routeID: pageNames.TicketSelectComponent,
            reuse: false,
        },
    },
    {
        path: 'payment',
        component: PayTicketComponent,
        data: {
            routeID: pageNames.PayTicketComponent,
            reuse: false,
        },
    },
    {
        path: 'affirmation',
        component: AffirmationComponent,
        data: {
            routeID: pageNames.AffirmationComponent,
            reuse: false,
        },
    },
    {
        path: 'viewdoc',
        component: ViewDocComponent,
        data: {
            routeID: pageNames.ViewDocComponent,
            reuse: false,
        },
    },
    {
        path: 'sampletickets/nassau',
        component: SampleTicketsNassauComponent,
        data: {
            routeID: pageNames.SampleTicketsNassauComponent,
            reuse: false,
        },
    },
    {
        path: 'receipt/:id',
        component: ReceiptComponent,
        data: {
            routeID: pageNames.ReceiptComponent,
            reuse: false,
        },
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
